module.exports = __webpack_public_path__ + "roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-700.90b12e163d7a549300a7.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Roboto/roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-700.svg
// module id = ../../../../../src/assets/fonts/Roboto/roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-700.svg
// module chunks = styles